import { getPermissionsByRoles } from '@vy/services';
import { ROLES, type Permission } from '@vy/types';
import { validateEnum, isNullOrUndefined } from '@vy/utils';
import type React from 'react';
import { getLocalStorageString } from '../utils/local-storage';
import { ROLE_KEY } from './user-auth/user-auth-consts';

export function renderWithPermissions(
  requiredPermissions: Permission[] | undefined,
  renderFn: (hasPermission: boolean) => React.ReactNode,
): React.ReactNode {
  const hasPermission = hasPermissions(requiredPermissions);

  return renderFn(hasPermission);
}

export function hasPermissions(requiredPermissions?: Permission[]): boolean {
  const role = getLocalStorageString(ROLE_KEY);

  if (isNullOrUndefined(role)) {
    return false;
  }

  if (isNullOrUndefined(requiredPermissions)) {
    return true;
  }

  validateEnum(role, ROLES);
  const userPermissions = getPermissionsByRoles(role);

  return requiredPermissions.some((permission) => userPermissions.includes(permission));
}
